module.exports = __webpack_public_path__ + "img/promo.edd5934b.gif";